import type React from 'react';

import { Separator } from '@change/ds-core-ui';

import { AdvocacySupport } from '../components/AdvocacySupport';
import { CampaignPhoto } from '../components/CampaignPhoto';
import { EndorsementsOverview } from '../components/EndorsementsOverview';
import { EndorsementsSectionList } from '../components/EndorsementsSectionList';
import { ProfileCardWrapper } from '../components/ProfileCardWrapper';
import { ResponseListWrapper } from '../components/ResponseListWrapper';
import { SapToDm } from '../components/SapToDm';
import { SummaryByAI } from '../components/SummaryByAI';
import { TargetedPetitionListWrapper } from '../components/TargetedPetitionListWrapper';
import { TopIssues } from '../components/TopIssues';
import { WebsitesContainer } from '../components/Websites';

import { useLayout } from './hooks/useLayout';

export const Layout: React.FC = () => {
	const {
		data: {
			dmReputationLayer: { isDmrlEnabled, hasCampaignPhotoOrWebsites, hasEndorsements, hasDmrlData },
		},
	} = useLayout();

	return (
		<div className="container pb-14">
			<ProfileCardWrapper />

			<div className="overflow-x-hidden px-4 md:px-0">
				<TargetedPetitionListWrapper />

				<ResponseListWrapper />

				{isDmrlEnabled && <TopIssues />}

				<SapToDm />

				{isDmrlEnabled && (
					<>
						{(hasEndorsements || hasCampaignPhotoOrWebsites) && (
							<Separator orientation="horizontal" className="my-14" />
						)}

						<>
							<EndorsementsOverview />
							<AdvocacySupport />
							<EndorsementsSectionList />
							{hasCampaignPhotoOrWebsites && <Separator orientation="horizontal" className="my-14" />}
						</>
						<div className="flex flex-col gap-14 md:flex-row">
							<CampaignPhoto />
							<WebsitesContainer />
						</div>

						{hasDmrlData && <SummaryByAI />}
					</>
				)}
			</div>
		</div>
	);
};
